import { SUCCESS } from "./success";
import { ERROR } from "./error";
import { INFO } from "./info";

export const MESSAGE = {
  SUCCESS,
  ERROR,
  INFO,
};
